module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_SK-3da347d98b945662e981868d12633aa7.svg";